import ApiHttp from "byzantine/src/ApiHttp";
import { useLocalization } from "@fluent/react";
import { Button, TextInput } from "@narmi/design_system";
import {
  ContextForm,
  Dialog,
  SimpleDateInput,
  TaxIDTextInput,
  useFormData,
  useLoadingContext,
  useNotificationContext,
} from "cerulean";

interface LinkInternalAccountModalProps {
  linkInternalAccountModalOpen: boolean;
  setLinkInternalAccountModalOpen: CallableFunction;
  fetchMemberships: CallableFunction;
}

interface MembershipPostResponse {
  message: string;
  email: string;
}
const LinkInternalAccountModal = ({
  linkInternalAccountModalOpen,
  setLinkInternalAccountModalOpen,
  fetchMemberships,
}: LinkInternalAccountModalProps) => {
  const { l10n } = useLocalization();
  const { formData, onChange, setFormData } = useFormData();
  const { sendNotification } = useNotificationContext();
  const { setIsLoading } = useLoadingContext();

  const onSubmit = async () => {
    setIsLoading(true);
    const payload = { ...formData, user_category: "personal" };
    try {
      const { message }: MembershipPostResponse = await ApiHttp.fetch(
        "accounts/membership",
        { method: "POST" },
        payload
      );
      setLinkInternalAccountModalOpen(false);
      setIsLoading(false);
      fetchMemberships();
      sendNotification({ type: "success", text: message });
    } catch (err: unknown) {
      setLinkInternalAccountModalOpen(false);
      setIsLoading(false);
      sendNotification({
        type: "negative",
        text: typeof err === "string" ? err : "There was an error linking your account.",
      });
    }
    setFormData({});
  };

  return (
    <Dialog
      isOpen={linkInternalAccountModalOpen}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button
            kind="negative"
            onClick={() => setLinkInternalAccountModalOpen(false)}
          >
            {l10n.getString("button-cancel")}
          </Button>
          <span className="margin--left--s">
            <Button onClick={onSubmit}>{l10n.getString("button-link-account")}</Button>
          </span>
        </div>
      }
      onUserDismiss={() => setLinkInternalAccountModalOpen(false)}
      title={l10n.getString("dialog-link-account-title")}
    >
      <div>{l10n.getString("dialog-link-account-description")}</div>
      <div className="padding--top--l">
        <ContextForm data={formData} onChange={onChange}>
          <ContextForm.Field required key="primary_account_number">
            <TextInput field="primary_account_number" label={l10n.getString("label-account-number")} />
          </ContextForm.Field>
          <ContextForm.Field required key="ssn">
            <TaxIDTextInput field="ssn" label={l10n.getString("label-social-security-number")} />
          </ContextForm.Field>
          <ContextForm.Field required key="date_of_birth">
            {/* @ts-expect-error certain props are omitted because this is in a ContextForm */}
            <SimpleDateInput field="date_of_birth" label={l10n.getString("label-date-of-birth")} />
          </ContextForm.Field>
        </ContextForm>
      </div>
    </Dialog>
  );
};

export default LinkInternalAccountModal;
